import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Delivery, DeliveryInformation, UpdateDeliveryRequest } from "src/app/domain/models/Delivery";
import { Routes } from "src/app/infrastructure/routes";
import { DeliveryGateway } from "../gateway/DeliveryGateway";

@Injectable({providedIn: 'root'})
export class DeliveryService extends DeliveryGateway {

  constructor(private _http: HttpClient) {
    super()
  }

  getById(deliveryId: number): Observable<Delivery> {
    return this._http.get<Delivery>(Routes.deliveryApi + '/GetById', {params: {deliveryId}})
  }

  getByImportOrderId(importOrderId: any): Observable<DeliveryInformation> {
    return this._http.get<DeliveryInformation>(Routes.deliveryApi + '/GetByImportOrderId', {params: {importOrderId}})
  }

  update(deliveryDto: UpdateDeliveryRequest): Observable<DeliveryInformation> {
    return this._http.put<DeliveryInformation>(Routes.deliveryApi + '/Update', deliveryDto)
  }

  removeNotification(importOrderId: any, notificationType: string): Observable<any> {
    return this._http.get<any>(Routes.deliveryApi + '/RemoveNotification', {params:{guid:  importOrderId, notificationType: notificationType }})
  }

  downloadPackingList(importOrderDetailId: string, withLabel: boolean, withPackaging : boolean, withSpeciesSize: boolean): Observable<any>{
    return this._http.post<any>(Routes.deliveryApi + '/DownloadPackingListExcel',{logoUrl: null}, {
      params:{importOrderDetailId, withLabel, withPackaging, withSpeciesSize },
      observe: 'response', responseType: 'blob' as 'json'})
  }

  downloadIsf(importOrderDetailGuid: string): Observable<any>{
        const headers = new HttpHeaders({
          'Content-Type':  'application/octet-stream'
        })
    return this._http.post<any>(Routes.deliveryApi + '/DownloadISFDocumentExcel',{logoUrl: null}, {
      params:{importOrderDetailGuid},
      headers: headers,
      observe: 'response',
      responseType: 'blob' as 'json'
    })
  }

  getRequestFile(request: any){
    const formData = new FormData();

    if(request)
    {
      if(request.file) formData.append("file", request.file)
    }
    return formData;
  }

  uploadPreBl(request: any): Observable<any>
  {
      var formData = this.getRequestFile(request);

      formData.append('importerId', request.importerId);

      return this._http.post(
        Routes.deliveryApi + '/UploadOrderPreBl',
        formData
      )
  }

  downloadPendingOrderFormat(importerId: number): Observable<any> {

    var formData = new FormData();

    formData.append('importerId', importerId.toString());
    const headers = new HttpHeaders({
      'Content-Type':  'application/octet-stream'
    })
    return this._http.get<any>(Routes.deliveryApi + '/DownloadPendingOrderFormat',{params: {importerId}, headers: headers, observe: 'response', responseType: 'blob' as 'json'})
  }
}
